import { LOGOUT_RTK } from "@/components/access/ducks/Actions"
import { errHof, httpPost } from "@/http"
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"

/**
 * @typedef {Object} UserClassNoteState
 * @property {boolean} imageLoading
 * @property {string} imageCaption
 * @property {string} imageLocation
 * @property {string} classNote
 */

/** @typedef {import("@reduxjs/toolkit").PayloadAction} PayloadAction */

/** @type {UserClassNoteState} */
const initialState = {
  classNote: "",
  imageCaption: "",
  imageLocation: "",
  imageLoading: false,
}

const submitClassNote = createAsyncThunk(
  "classNote/user/submitClassNote",
  async ({ onSuccess, onError }, { rejectWithValue, getState, signal }) => {
    /** @type {UserClassNoteState} */
    const state = getState().classNotes.user

    const { classNote, imageLocation, imageCaption } = state

    try {
      await httpPost(
        "classNote",
        { classNote, imageCaption, imageLocation },
        {
          signal,
          success: onSuccess,
          error: errHof(onError, "submitClassNote", rejectWithValue),
        },
      )
    } catch (err) {
      rejectWithValue(err)
    }
  },
)

const classNoteUserSlice = createSlice({
  name: "classNote/user",
  initialState,
  reducers: {
    changeNote(state, action) {
      state.classNote = action.payload
    },
    setImageLoading(state, action) {
      state.imageLoading = action.imageLoading
    },
    changeNoteCaption(state, action) {
      state.imageCaption = action.payload
    },
    setClassNoteImageLocation(state, action) {
      state.imageLocation = action.payload
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(LOGOUT_RTK, (_state, _action) => {
        return initialState
      })
      .addCase(submitClassNote.rejected, (state, _action) => {
        state.imageLoading = false
      })
      .addCase(submitClassNote.fulfilled, (state, _action) => {
        state.classNote = ""
        state.imageLoading = false
        state.imageCaption = ""
        state.imageLocation = ""
      })
  },
})

export const ClassNoteUserActions = {
  ...classNoteUserSlice.actions,
  submitClassNote,
}

export default classNoteUserSlice.reducer
